/**
 * 页脚
 */
import '../../css/common/footer.less';
import React, { Component } from "react";
import Tooltip from 'rc-tooltip';
import { Link } from 'react-router';
import lang from '../lang/index';
import iframePop from '../lib/popup/iframe';
import imgLists from './country-list'

class FooterView extends Component {
	
	constructor(props) {
        super(props);
        
        let countryCode = UP.Global.getUser().countryCode;
        let imgList;

        if (UP.Global.version == 'CN') {
        	imgList = imgLists['CN'];
        } else {
        	imgList = imgLists[countryCode || 'US'];
        }

        this.state = {
            navs: [

                {
                    text: lang.template('关于我们'),
                    path: '/about',
                    type: 'about'
                },
                {
                    text: lang.template('联系我们'),
                    path: '/contact',
                    type: 'contact'
                }
            ],
			imgList: imgList
        }
	}
	
	onSelect=(item, e)=>{
		let countryCode = UP.Global.getUserCountryCode();
		let country;

		if (countryCode) {
			country = UP.Global.middelEastCountryCodes.indexOf(countryCode) > -1 ? 'AR': countryCode;
		} else {
			country = UP.Global.siteLanguage.split('-')[1]; // 如果用户没有登录，默认用语言最后两位
		}
		
		if (item.type == 'contact') {
			if(UP.Global.version == 'CN'){
				let url = lang.template('contact.html');
				
				if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
					window.open(url);
				} else {
					iframePop.create({
						url: UP.Global.getH5Host() + url + '?lang=' + UP.Global.siteLanguage + '&country=' + country
					});
				}
			} else {
				window.open(location.origin+'/contact.html');
				// iframePop.create({
				// 	url: location.origin+'/contact.html'
				// });
			}
		}else if(item.type == 'service'){
			iframePop.create({
				url: item.path
			});
		} else {
			window.hashHistory.push(item.path);
		}
    }

	render() {
		let { navs , imgList } = this.state;
		let $icons, $extra;

		if(imgList !=undefined) {
            $icons = imgList.map((item ,index)=>{
                if (item.name == 'weixin') {
                    return (
                        <a key={index} className='icon' href= "javascript:void(0);">
                            <Tooltip overlay={<i className="wx-twocard"></i>} placement="bottom" trigger={['hover']} overlayClassName="footer-popover-qrcode">
                                <i className={item.name}></i>
                            </Tooltip>
                        </a>
                    )
                } else {
                    return (
                        <a key={index} className='icon' href= {item.path} target = "_blank">
                            <i className={item.name}></i>
                        </a>
                    )
                }
            });
		}else {
            $icons =null;
		};


		if (UP.Global.version == 'CN') {
			$extra = (
				<div className="footer-extra">
					<ul>	
						<li><a href={require('../../images/common/www-w-fb.jpg')} target="_blank">{lang.template('京网文（2016）5432-700号')}</a> |</li>
						<li><a href={require('../../images/common/www-y-fb.jpg')} target="_blank">{lang.template('京演(机构)（2018) 3660号')}</a> |</li>
						<li>{lang.template('京ICP备14002814号')} |</li>
						<li><a href={require('../../images/common/ICP.jpg')} target="_blank">{lang.template('增值电信业务经营许可证：京B2-20180910')}</a></li>
					</ul>
					<p className="address">公司地址：北京市朝阳区广顺南大街16号院2号楼9层925室</p>	
					<div className="beian">
		 				<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037529">
		 					<img src="https://g.cdn.pengpengla.com/oauthgame/html5/20190329/8c62318f7b6da0cb7277042564e07196.png"/>
		 					<span>京公网安备 11010502037529号</span>
		 				</a>
		 			</div>
				</div>
			)
		}
		if (UP.Global.version != 'CN'){
			let terms = {
				'pt-PT':{
					policy:'https://h5.upliveapp.com/zencms/5d197c2f93ebcd64853835c9.html',
					service: 'https://h5.upliveapp.com/zencms/5d197bd793ebcd64853835c8.html'
				},
				'es-ES':{
					policy:'https://h5.upliveapp.com/zencms/5d1487ff93ebcd64853835c6.html',
					service: 'https://h5.upliveapp.com/zencms/5d14887193ebcd64853835c7.html'
				},

				'en-US':{
					policy:'https://h5.upliveapp.com/zencms/5ce6489d87bec5782690446c.html',
					service: 'https://h5.upliveapp.com/zencms/5ce6491687bec5782690446d.html'
				},
			};
			let term = terms[UP.Global.siteLanguage] || terms['en-US'];
			let extraNav = [
				    {
	                    text: lang.template('Privacy Policy'),
	                    path: term['policy'],
	                    type: 'service'
	                },
				    {
	                    text: lang.template('Terms of Service'),
	                    path: term['service'],
	                    type: 'service'
	                },
			];
			navs = [...navs,...extraNav];
		}
		let copyright;
		if(UP.Global.version == 'CN'){
			copyright = '© 2019 云智联网络科技（北京）有限公司';
		}else{
			copyright = '© 2019 All Rights Reserved up.live';//© 2019 All Rights Reserved Asia Innovations Ltd
		}   

		return (
			<div className="footer" id="J-Footer">
				<div className="footer-container">
					<div className='footer-left'>
                        <span className='logo'></span>
                        <span className="copyright">
                        {copyright}
                        </span>
					</div>
					<div className="footer-nav">
						<ul className="nav-list clearfix">
							{
								navs.map((item, index)=>{
				                    return (
				                        <li key={index}>
				                            <h2 onClick={this.onSelect.bind(this, item)}>
				                                {item.text}
				                            </h2>
				                        </li>
				                    )
								})
							}
						</ul>
					</div>
					{
						UP.Global.version != 'CN' ?(<div className="qianhai"><div className="pic"></div><span className="text"><a href={`${location.origin}/qianhai.html`}  target="_blank">{lang.template('INTELLECTUAL PROPERTY RIGHTS')}</a></span></div>):null

					}
					
					<div className="social-icons">
						{ $icons }
					</div>
				</div>
				{ $extra }
			</div>
		);
	}
}

export default FooterView;



// WEBPACK FOOTER //
// ./js/footer/index.js